import { render, staticRenderFns } from "./WatchListInfiniteScroll.vue?vue&type=template&id=dc094f48"
import script from "./WatchListInfiniteScroll.vue?vue&type=script&lang=ts"
export * from "./WatchListInfiniteScroll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports